import PropTypes from "prop-types";
import { ListGroup, Badge } from "react-bootstrap";
import { FaHeadset, FaPlus, FaCalendarAlt, FaCoins, FaFileMedicalAlt, FaFileAlt, FaFileMedical, FaHome, FaBoxOpen, FaRegHandshake } from "react-icons/fa";
import { hasPerm, getCurrentUser, prestadorOcultaFaturamento } from '../../common/utils';
import { getConfig } from "../../common/config";
import { useTranslation } from 'react-i18next';

// noDashboard ja era usado abaixo mas nao estava sendo recebido: so nao quebrava porque
// o `&&` curto-circuita fora da raiz. Na rota "/" daria ReferenceError.
const MenuPrestador = ({ pathname, faturamentosPendentes, noDashboard, habilitar_indicacao_profissional }) => {
  const { t } = useTranslation(['menu']);
  const dados_usuario = getCurrentUser();

  //prestador marcado no cadastro para nao ver a gestao financeira
  const ocultaFinanceiro = prestadorOcultaFaturamento(dados_usuario);

  const configuracoes_programa = localStorage.getItem(`programa_configuracoes_${dados_usuario['ambiente_programa_id']}`);

  return (
    <>

        {dados_usuario["prestador_categoria"] == "medicos" && (
            <ListGroup variant="flush">
            <ListGroup.Item
                action
                href="/"
                className="itemMenu"
                active={pathname === "/"}
            >
                <FaHome /> {t('menu:item.home')}
            </ListGroup.Item>
            </ListGroup>
        )}

      <div className="list-divider">
        <p>{t('menu:section.patientCare')}</p>
      </div>

        {hasPerm("view_agendamentos") && dados_usuario['prestador_categoria'] !== 'medicos' && (
            <>
            {/* Agenda (calendário) e Agendamentos (listagem) são vistas complementares do
                mesmo dado: o calendário mostra a semana, a listagem permite filtrar e agir
                item a item. Quem tem a agenda liberada passa a ver as duas. */}
            {(getConfig(configuracoes_programa, "libera_agenda_prestador", false) === true || dados_usuario['ambiente_programa_id'] === 35 || dados_usuario['ambiente_programa_id'] === 11) && (
                <ListGroup variant="flush">
                    <ListGroup.Item action href="/agendas" className="itemMenu" active={pathname === "/agendas" || pathname === "/agendas/" || (pathname === "/" && noDashboard)} >
                        <FaCalendarAlt /> {t('menu:item.schedule')}
                    </ListGroup.Item>
                </ListGroup>
            )}
            <ListGroup variant="flush">
                <ListGroup.Item action href="/agendamentos" className="itemMenu" active={pathname.indexOf('/agendamentos') !== -1}>
                    <FaCalendarAlt /> {t('menu:item.appointments')}
                </ListGroup.Item>
            </ListGroup>
            </>
        )}

        {hasPerm("view_atendimentos") && (
            <ListGroup variant="flush">
                <ListGroup.Item action href="/atendimentos" className="itemMenu" active={pathname.indexOf("/atendimentos") !== -1} >
                    <FaHeadset /> {t('menu:item.patients')}
                </ListGroup.Item>
            </ListGroup>
        )}

        {hasPerm("add_atendimentos") && hasPerm("view_atendimentos") && (
            <ListGroup variant="flush">
                <ListGroup.Item action href="/atendimentos/add" className="itemMenu">
                    <FaPlus /> {t('menu:item.newPatient')}
                </ListGroup.Item>
            </ListGroup>
        )}

        {/* Os rótulos `menu_medico.label_*` são configurados por programa e prevalecem;
            só o valor padrão (programa sem configuração) é traduzido. */}
        {hasPerm('view_exames') && dados_usuario?.prestador_categoria === 'medicos' && (
        <ListGroup variant="flush">
            <ListGroup.Item action href="/exames" className="itemMenu" active={pathname.indexOf('/exames') !== -1}>
                <FaFileMedical /> {getConfig(configuracoes_programa, "menu_medico.label_exames", t('menu:item.examsAndReports'))}
            </ListGroup.Item>
        </ListGroup>
        )}

        {dados_usuario?.prestador_categoria === 'medicos' && getConfig(configuracoes_programa, "medico_solicita_kit", false) === true && (
            <ListGroup variant="flush">
                <ListGroup.Item action href="/meus-kits" className="itemMenu" active={pathname.indexOf('/meus-kits') !== -1}>
                    <FaBoxOpen /> {getConfig(configuracoes_programa, "menu_medico.label_kits", t('menu:item.requestKit'))}
                </ListGroup.Item>
            </ListGroup>
        )}

        {hasPerm('view_farmacovigilancia') && getConfig(configuracoes_programa, "farmacovigilancia.reporte_prestador", false) === true && (
            <ListGroup variant="flush">
                <ListGroup.Item
                    action
                    href="/reportes-farmaco"
                    className="itemMenu"
                    active={pathname.indexOf("/reportes-farmaco") !== -1}
                >
                    <FaFileMedicalAlt /> {t('menu:item.reportAdverseEvent')}
                </ListGroup.Item>
            </ListGroup>
        )}

        {dados_usuario?.prestador_categoria === 'medicos' && (
            <>
                <div className="list-divider">
                    <p>{t('menu:section.terms')}</p>
                </div>
                <ListGroup variant="flush">
                    <ListGroup.Item action href="/termos-medicos" className="itemMenu" active={pathname.indexOf('/termos-medicos') !== -1}>
                        <FaFileAlt /> {getConfig(configuracoes_programa, "menu_medico.label_termos", t('menu:item.termsOfUse'))}
                    </ListGroup.Item>
                </ListGroup>
            </>
        )}

        {/* só aparece em programa que oferece indicação */}
        {dados_usuario?.prestador_categoria === 'medicos' && habilitar_indicacao_profissional && (
            <>
                <div className="list-divider">
                    <p>{t('menu:section.referrals')}</p>
                </div>
                <ListGroup variant="flush">
                    <ListGroup.Item action href="/indicacoes-profissionais" className="itemMenu" active={pathname.indexOf('/indicacoes-profissionais') !== -1}>
                        <FaRegHandshake /> {getConfig(configuracoes_programa, "menu_medico.label_indicacoes", t('menu:item.professionalReferral'))}
                    </ListGroup.Item>
                </ListGroup>
            </>
        )}

        {!ocultaFinanceiro && hasPerm("view_faturamentos") && (
            <>
                <div className="list-divider">
                    <p>{t('menu:section.financial')}</p>
                </div>
                <ListGroup variant="flush">
                    <ListGroup.Item action href="/faturamentos" className="itemMenu" active={pathname.indexOf("/faturamentos") !== -1} >
                        <FaCoins /> {t('menu:item.billing')}
                        {faturamentosPendentes > 0 && (
                            <Badge pill bg="danger" className="ms-2">
                            {faturamentosPendentes}
                            </Badge>
                        )}
                    </ListGroup.Item>
                </ListGroup>
            </>
        )}

    </>
  );
};

MenuPrestador.propTypes = {
  pathname: PropTypes.string.isRequired,
  faturamentosPendentes: PropTypes.number,
  // Vem de SidebarV2 via commonMenuProps; sem declarar, o menu quebrava ao
  // avaliar `pathname === "/" && noDashboard` na home do prestador.
  noDashboard: PropTypes.bool,
  habilitar_indicacao_profissional: PropTypes.bool,
};

export default MenuPrestador;
